import firebase from 'firebase/app'
import VueFire from 'vuefire'
import * as firebaseui from 'firebaseui'
import 'firebase/storage'
import 'firebase/firestore'
import Vue from 'vue';


Vue.use(VueFire)

const config = {
    apiKey: "AIzaSyCi0Qtxu6dw_ZvEiAv3OkjYU6sIq_rutT4",
    authDomain: "baby-prono.firebaseapp.com",
    databaseURL: "https://baby-prono.firebaseio.com",
    projectId: "baby-prono",
    storageBucket: "baby-prono.appspot.com",
    messagingSenderId: "135737401876"
}

export const firebase_app = !firebase.apps.length ? firebase.initializeApp(config): firebase.app()
export const auth = firebase.auth()
// export const database = firebase.database()
export const storage = firebase.storage()
export const firestore = firebase.firestore()
export const ui = new firebaseui.auth.AuthUI(firebase.auth());
export const uiConfig = {
    signInFlow: 'popup',
    signInOptions: [
    // Leave the lines as is for the providers you want to offer your users.
        firebase.auth.GoogleAuthProvider.PROVIDER_ID,
        firebase.auth.FacebookAuthProvider.PROVIDER_ID,
        firebase.auth.TwitterAuthProvider.PROVIDER_ID,
        firebase.auth.GithubAuthProvider.PROVIDER_ID,
        firebase.auth.EmailAuthProvider.PROVIDER_ID,
        firebaseui.auth.AnonymousAuthProvider.PROVIDER_ID
    ],
    // tosUrl and privacyPolicyUrl accept either url string or a callback
    // function.
    // Terms of service url/callback.
    // tosUrl: '',
    // Privacy policy url/callback.
    // privacyPolicyUrl: function() {
    //     //
    // }
};

export const fromDate = firebase.firestore.Timestamp.fromDate
export const fieldValue = firebase.firestore.FieldValue

firestore.settings({ timestampsInSnapshots: true })


export default {
  firebase: firebase_app,
  // database,
  storage,
  auth,
  firestore,
  fromDate,
  ui,
  fieldValue: firebase.firestore.FieldValue
}